import React from 'react';
import TopBar from "./TopBar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import DesignsGallery from "./DesignsGallery";

const Designs = () => {
    return (
        <>
            <TopBar/>
            <Navbar/>
            <DesignsGallery/>
            <Footer/>
        </>
    );
};

export default Designs;